import IMG1 from '../../../assets/img/certificates/certificates14001.png';
import IMG2 from '../../../assets/img/certificates/RINA.jpg';
import IMG3 from '../../../assets/img/certificates/certificates45001.png';
import IMG4 from '../../../assets/img/certificates/SOA_rilascio.jpg';
import IMG5 from '../../../assets/img/certificates/politica_qualita.jpg';

import PDF1 from '../../../assets/certificates/1_CertificatoISO14001n2464em1.pdf';
import PDF2 from '../../../assets/certificates/2025.12.11 - 2022.12.11 - FCSI - ISO 9001_2015 Cert.  Conformità nr.  34581_16_S.pdf';
import PDF3 from '../../../assets/certificates/3_CertificatoISO45001n2465em1.pdf';
import PDF4 from '../../../assets/certificates/4_SOA_OG10_CLASS_VI_&_OG11_CLASS_VIII.pdf';
import PDF5 from '../../../assets/certificates/FCSI-PIQAS_Politica Integrata Qualità Ambiente Sicurezza FCSI_Rev. C del 2022.11.16_Signed.pdf';

export const nameCertificates = [
  {
    image: IMG1,
    title: 'UNI EN ISO 14001:2015',
    url: PDF1,
  },
  {
    image: IMG2,
    title: 'ISO 9001:2015',
    url: PDF2,
  },
  {
    image: IMG3,
    title: 'UNI ISO 45001:2018',
    url: PDF3,
  },
  {
    image: IMG4,
    title: 'SOA OG10 Class. VI & OG11 Class. VIII',
    url: PDF4,
  },
  {
    image: IMG5,
    title: 'Politica per la qualità, l’ambiente e la sicurezza sul lavoro',
    url: PDF5,
  },
];
